import { makeStyles } from "@material-ui/core";

const useSelectWrapStyles = makeStyles(
  ({ palette: { type, primary, error, custom } }) => ({
    root: (props) => ({
      boxSizing: "border-box",
      minHeight: 32,
      marginTop: "0 !important",
      border: `1px solid ${custom.border["400"]}`,
      borderRadius: props.rounded ? 16 : 4,
      backgroundColor: custom.high,
      "&::before": {
        content: "none !important",
      },
      "&::after": {
        content: "none !important",
      },
      "&.Mui-focused": {
        border: `1px solid ${primary.main}`,
        boxShadow: `0 0 4px ${primary.main}`,
      },
      "&.Mui-error": {
        border: `1px solid ${error.main}`,
        "&.Mui-focused": {
          boxShadow: `0 0 ${type === "dark" ? 8 : 4}px ${error.main}`,
        },
      },
    }),
  })
);

export default useSelectWrapStyles;
